<template>
  <div class="metadata-modal">
    <div class="body" ref="body">
      <type-field 
        :root="rootNode" 
        :type="formData.type" 
        :limitCompType="limitCompType"
      ></type-field>
      <div class="grid-col-1-4 grid-row-3-4">
        <editor
          :init="{
            height: 500,
            content_style: 'body { font-family: system-ui; }',
            plugins: 
              'preview paste searchreplace autolink save directionality code visualblocks visualchars \
              image link media table charmap hr nonbreaking anchor insertdatetime advlist lists wordcount \
              charmap quickbars emoticons pagebreak',  
            toolbar1: 
              'undo redo | fontselect fontsizeselect formatselect | bold italic underline strikethrough | \
              alignleft aligncenter alignright alignjustify | outdent indent',
            toolbar2: 'numlist bullist | forecolor backcolor removeformat | pagebreak | quickimage media link',
            quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
            font_formats: 
              'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; \
              Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; \
              Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; System UI=system-ui,sans-serif\
              Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; \
              Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings,zapf dingbats',
          }"
          v-model="formData.content"
          id="tinyeditor"
        />
      </div>
      <div class="grid-col-1-4 grid-row-4-5">
        <slot></slot>
      </div>
      <fieldset v-if="!simpleView" class="more-option grid-col-1-4 grid-row-5-6">
        <legend>
          More Options
        </legend>
      </fieldset>
      <div class="input-block grid-col-1-4 grid-row-6-7" v-if="!simpleView">
        <label>
          Raw HTML
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.RAW_HTML"></tooltip>
        </label>
        <input type="text" v-model="formData.content" name="content" required />
      </div>
    </div>
  </div>
</template>

<script src="/path/to/tinymce/tinymce.min.js"></script>

<script>
import { TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { clearUndo, resetTextEditor } from "../mixins/tinymce-utils-mixin";
import TypeField from "./TypeField.vue";
import Tooltip from "./Tooltip.vue";
import { Bus } from "../main";

import Editor from "@tinymce/tinymce-vue";
import tinymce from "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.inline.min.css";

import "tinymce/plugins/advlist";
import "tinymce/plugins/charmap";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/media";
import "tinymce/plugins/print";
import "tinymce/plugins/table";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/anchor";
import "tinymce/plugins/code";
import "tinymce/plugins/importcss";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/template";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/autolink";
import "tinymce/plugins/codesample";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/noneditable";
import "tinymce/plugins/save";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/help";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/autosave";
import "tinymce/plugins/hr";
import "tinymce/plugins/link";
import "tinymce/plugins/paste";
import "tinymce/plugins/directionality";
import "tinymce/plugins/image";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/lists";
import "tinymce/plugins/preview";
import "tinymce/plugins/tabfocus";
import "tinymce/plugins/visualblocks";

export default {
  name: "StaticNTModal",
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
    limitCompType: {
      type: String,
    },
    root: {
      type: String,
    },
  },
  data() {
    return {
      formData: structuredClone(this.metadata),
      rootNode: this.root,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
    };
  },
  watch: {
    metadata: function () {
      this.formData = structuredClone(this.metadata);
    },
    state: function () {
      if (this.state.closing) {
        if (this.state.saving) {
          this.$emit("metadataSaved", this.formData);
        } else {
          this.formData = structuredClone(this.metadata);
        }
        clearUndo();
        resetTextEditor("tinyeditor");
      }
    },
    simpleView: function() {
      this.insertIntoComponentModal();
    },
  },
  components: {
    "type-field": TypeField,
    "tooltip": Tooltip,
    editor: Editor,
  },
  mounted() {    
    this.insertIntoComponentModal();
  },
  methods: {
    getCompType: function (type) {
      return type.toLowerCase() === this.formData.type.toLowerCase();
    },
    insertIntoComponentModal: function () {
      const gridRow = "2 / 3";
      Bus.$emit("insertIntoComponentModal", this.$refs.body, gridRow);
    },
  },
};
</script>

<style scoped>
.metadata-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
}

.body > div {
  padding: 0 2rem;
}

.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

.remove {
  text-align: center;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 0 9px 3px 9px;
  margin-top: 3px;
  cursor: pointer;
  font-weight: bolder;
}

.grid-col-1-4 {
  grid-column: 1 / 4;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.grid-row-4-5 {
  grid-row: 4 / 5;
}

.grid-row-5-6 {
  grid-row: 5 / 6;
}

.grid-row-6-7 {
  grid-row: 6 / 7;
}

.more-option {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #808080;
  text-align: center;
}

.more-option > legend {
  padding: 0 0.5rem;
}

.required {
  color: #f00;
}
</style>